import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {BlockProps} from '../../lib/Block'
import {DynamicSlotName} from '../../lib/DynamicSlotName'
import {DynamicSlot} from './DynamicSlot'

///////////////////////////////////////////////////////////////////////////////

export type SlotBlockProps = BlockProps & {
  slotName?: string
}

///////////////////////////////////////////////////////////////////////////////

export const SlotBlock: FC<SlotBlockProps> = observer((props) => {
  let {position, slotName} = props
  slotName = slotName || 'slot_block_' + position

  return (
    <section className="widget-block slot-block">
      <div className="widget-block-header">
        <DynamicSlot name={slotName as DynamicSlotName} position={position} />
      </div>
    </section>
  )
})
